export const RegKoregavimasEnum = [
  'VEIKLOS_SUSTABDYMAS',
  'REGISTRACIJOS_NUTRAUKIMAS',
  'VEIKLOS_ATNAUJINIMAS',
  'AUTO_VEIKLOS_SUSTABDYMAS',
  'AUTO_REGISTRACIJOS_NUTRAUKIMAS',
  'AUTO_VEIKLOS_ATNAUJINIMAS'
] as const;

export type RegKoregavimasEnumType = typeof RegKoregavimasEnum[number];
